import { FC, useState } from 'react';
import { Trans } from 'react-i18next';
import { Button, Form } from 'antd';
import cn from 'classnames';

import { CheckBoxField, FormItem, SubmitButton } from 'componets/form';
import { ModalComponent } from 'componets/common';

import { FieldData, ModalProps } from 'models';

import { useAppSelector, useTranslate } from 'hooks';

import { Rules } from 'utils/constants';
import { language } from 'utils';

import { selectIsAdmin } from 'selectors';

import styles from './index.module.scss';

interface RiskNoticeProps extends ModalProps {
	onFinish: () => void;
	loading: boolean;
}

export const RiskNotice: FC<RiskNoticeProps> = ({ isOpen, onClose, onFinish, loading }) => {
	const { riskNoticeText, cancelText, gotItRiskText } = useTranslate([
		'riskNoticeText',
		'cancelText',
		'gotItRiskText',
	]);

	const isAdmin = useAppSelector(selectIsAdmin);

	const [fields, setFields] = useState<FieldData[]>([]);

	const isEn = ['en','ro'].includes(language);

	return (
		<ModalComponent
			isOpen={isOpen}
			onClose={onClose}
			title={riskNoticeText}
			width="516px"
			className={styles.root}
		>
			<div className="modal-content">
				<div className="modal-text">
					<Trans i18nKey="riskNoticeModalText" components={{ space: <br /> }} />
				</div>

				<Form onFinish={onFinish} onFieldsChange={setFields} fields={fields}>
					<FormItem
						name="agree"
						rules={[Rules.REQUIRED_CHECKBOX]}
						className="modal-checkbox checkbox"
					>
						<CheckBoxField
							text={
								<Trans
									i18nKey="confirmRisksText"
									components={{
										l: (
											<a
												className="modal-agreeLink"
												href={
													isEn
														? 'https://crowdpear.com/wp-content/uploads/2023/08/Description_of_risks_related_to_investment_in_crowdpear_platform.pdf'
														: 'https://crowdpear.com/wp-content/uploads/2023/08/Riziku_susijusiu_su_investavimu_crowdpear_platformoje_aprasas.pdf'
												}
												type="button"
												target="_blank"
												rel="noreferrer"
											/>
										),
									}}
								/>
							}
						/>
					</FormItem>

					<div className="modal-footer">
						<SubmitButton
							text={gotItRiskText}
							classNameWrapper={styles.submitWrapper}
							className={cn(styles.submit, { 'ant-btn-grey': isAdmin })}
							loading={loading}
						/>
						<Button onClick={onClose}>{cancelText}</Button>
					</div>
				</Form>
			</div>
		</ModalComponent>
	);
};
